// Fetches METAR wind observations from NOAA Aviation Weather Center (global airports, 7-day max history)

import { StationSeries, Observation } from './StationSeries.js';

const BASE_URL = 'https://aviationweather.gov/api/data/metar';

export class NoaaMetarProvider {

  constructor(base = BASE_URL, fetchFn = fetch.bind(globalThis)) {
    this.fetchFn = fetchFn;
    this.base = base;
  }

  async fetch(start, end, bbox, now = Date.now()) {
    const data = await this.fetchData(start, end, bbox, now);
    if (!Array.isArray(data)) {
      console.warn('NoaaMetarProvider: unexpected response, skipping parse:', data);
      return [];
    }
    const stations = this.parseMetarData(data, start, end);
    return stations.filter(s => s.observations.length > 0);
  }

  async fetchData(start, end, bbox, now = Date.now()) {
    const hoursBack = Math.ceil((now - start) / (1000 * 3600));
    const url = `${this.base}?bbox=${bbox.minLat},${bbox.minLon},${bbox.maxLat},${bbox.maxLon}&hours=${hoursBack}&format=json`;
    const res = await this.fetchFn(url);
    return res.json();
  }

  parseMetarData(data, start, end) {
    const stations = new Map();
    for (const obs of data) {
      const { icaoId, name, lat, lon, reportTime, wdir, wspd } = obs;
      if (!stations.has(icaoId))
        stations.set(icaoId, new StationSeries(icaoId, name, lat, lon, 'noaa-metar'));
      const t = new Date(reportTime).getTime();
      if (t < start || t > end) continue;
      if (wdir == null && wspd == null) continue;
      stations.get(icaoId).addObservation(new Observation(t, wdir ?? null, wspd ?? null));
    }
    const result = [...stations.values()];
    result.forEach(s => s.sortObservations());
    return result;
  }

}
